import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { hintHide } from '../../../../../../../hints/effects/hintHide';
import { EHintKey } from '../../../../../../../hints';

export const onHideHint = (): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState
    ) => {
        return dispatch(hintHide(EHintKey.KANBAN_CARD_RENAME));
    };
};
